module.exports = __webpack_public_path__ + "img/account_balance.bb45cf66.png";